<div class="bulk-actions">
  @if (selectedTaxReturnIds.length>0) {
  <div class="bulk-actions__intro">
    Bulk process <strong>{{ selectedTaxReturnIds.length }}</strong> selected
    {{ taxReturnAlias }}s with an option below:
  </div>
  } @if (selectedTaxReturnIds.length<=0) {
  <div class="bulk-actions__intro">
    {{ 'please-select-tax-return-alias-s-below-for-bulk-process' | transloco: {taxReturnAlias} }}
  </div>
  }
  <div class="bulk-actions__row">
    <div class="bulk-actions__checkbox">
      <div class="ui checkbox">
        <input
          #selectAllCheckBox
          type="checkbox"
          [(ngModel)]="selectAll"
          (change)="updateSelectAll(selectAll)"
        /><label>&nbsp;</label>
      </div>
    </div>

    <div class="bulk-actions__item">
      <select
        [(ngModel)]="selectedActionId"
        (ngModelChange)="selectAction($event)"
      >
        <option style="font-size: 150%;" value="">{{
          "select-an-action" | transloco
        }}</option>
        @for (action of actionList; track action) {
        <option style="font-size: 150%;" [value]="action.id">
          {{ action.label }}
          {{
            (action.id === "GENERATE_PACKAGE" || action.id === "DRAFT") &&
            isPackageGenerating
              ? "(In Progress)"
              : ""
          }}
        </option>
        }
      </select>
    </div>
    <div class="bulk-actions__item">
      @if (errorMessage) {
      <span class="error-message">{{ errorMessage }}</span>
      }
    </div>
  </div>
</div>
